/*
 * -----------------------------------------------------------------------
 *  <copyright file="menu-button/index.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cn from 'clsx';
import React from 'react';
import { MenuButtonProps } from './menu-button.interface';
import './styles.scss';

const MenuButton = ({ title, active, action, icon, className = '', rotation }: MenuButtonProps) => (
    <button type="button" className={cn('setting-btn', className, { 'setting-btn--active': active })} onClick={action}>
        <div className="setting-btn__icon">
            <FontAwesomeIcon className="" icon={icon} rotation={rotation} />
        </div>
        {title}
        <FontAwesomeIcon className="setting-btn__chevron" icon={['far', 'chevron-right']} />
    </button>
);

export default MenuButton;
